import React, { useEffect, useRef } from 'react';
import './MenuDialog.css';

const MenuDialog = ({ isOpen, onClose, label, mainItems }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    const handleClickOutside = (e) => {
      if (dialogRef.current && !dialogRef.current.contains(e.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Group items by category
  const groupedItems = mainItems.reduce((groups, item) => {
    const category = item.itemGroupName || 'Main Items';
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(item);
    return groups;
  }, {});

  return (
    <div className="menu-dialog-overlay">
      <div className="menu-dialog-container" ref={dialogRef}>
        <div className="menu-dialog-header">
          <h3 className="menu-dialog-title">
            {label} ({mainItems.length})
          </h3>
          <button className="menu-dialog-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="menu-dialog-content">
          {Object.entries(groupedItems).map(([category, items]) => (
            <div key={category} className="menu-dialog-section">
              <div className="menu-dialog-section-title">
                {category.toUpperCase()}
              </div>
              <div className="menu-dialog-items">
                {items.map((item, idx) => (
                  <div key={idx} className="menu-dialog-item">
                    <span className="menu-dialog-item-name">{item.itemName}</span>
                    <span className="menu-dialog-item-qty">({item.qty})</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuDialog;